import React from 'react'

function LogoutIcon({
  className,
  stroke,
  size
}) {
  return (
    <div className={className} aria-hidden="true">
      <svg xmlns="http://www.w3.org/2000/svg" className={size? size : "h-6 w-6"} fill="none" viewBox="0 0 24 24" stroke={stroke}>
         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
      </svg>
    </div>
  )
}

export default LogoutIcon;